import { UiCalloutModel } from "../../models";

import { mockAdfDocument, mockUiImageModel } from "./";

export function mockUiCalloutModel({
    id = "Callout-1234",
    type = "uiCallout",
    locale = "en",
    content = mockUiCalloutModelContent()
}: Partial<UiCalloutModel> = {}): UiCalloutModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiCalloutModelContent = UiCalloutModel["content"];

export function mockUiCalloutModelContent({
    entryTitle = "Example Callout",
    heading = "Example Callout",
    media = mockUiImageModel(),
    text = mockAdfDocument(),
    ...optionals
}: Partial<UiCalloutModelContent> = {}): UiCalloutModelContent {
    return {
        entryTitle,
        heading,
        media,
        text,
        ...optionals
    };
}
